import React from "react";
import {Checkbox, Select} from "antd";
import {ColumnsType} from "antd/es/table";
import {Translate} from "../../../../hooks/translate.hook";
import {System} from "../../../../models/systems/system/system";
import {Group} from "../../../../models/users/group/group";
import {SystemAccessFormValue} from "./system.accesses.types";

interface SystemAccessColumnsFactoryParams {
    t: Translate;
    loading: boolean;
    groupsLoading: boolean;
    accessesBySystemId: ReadonlyMap<string, SystemAccessFormValue>;
    groupsBySystemId: ReadonlyMap<string, Group[]>;
    onToggleSystem: (systemId: string, checked: boolean) => void;
    onSelectGroup: (systemId: string, groupId: number) => void;
}

export const createSystemAccessColumns = ({
    t,
    loading,
    groupsLoading,
    accessesBySystemId,
    groupsBySystemId,
    onToggleSystem,
    onSelectGroup,
}: SystemAccessColumnsFactoryParams): ColumnsType<System> => [
    {
        title: t("SYSTEM"),
        key: "system",
        render: (_, system) => (
            <Checkbox
                checked={accessesBySystemId.has(system.id)}
                disabled={loading}
                onChange={(event) => onToggleSystem(system.id, event.target.checked)}
            >
                {system.name}
            </Checkbox>
        ),
    },
    {
        title: t("GROUP.TITLE"),
        key: "group",
        width: "50%",
        render: (_, system) => {
            const access = accessesBySystemId.get(system.id);
            const groups = groupsBySystemId.get(system.id) ?? [];

            return (
                <Select
                    showSearch
                    optionFilterProp="children"
                    value={access?.group}
                    disabled={!access || loading || groupsLoading}
                    loading={groupsLoading}
                    placeholder={t("GROUP.TITLE")}
                    style={{width: "100%"}}
                    onChange={(groupId) => onSelectGroup(system.id, groupId)}
                >
                    {groups.map((group) => (
                        <Select.Option key={group.id} value={group.id}>
                            {group.name}
                        </Select.Option>
                    ))}
                </Select>
            );
        },
    },
];
